import { Card, CardContent } from "~/components/ui/card";
import { Skeleton } from "~/components/ui/skeleton";

export default function BlogSkeletonCard({
    displayMode
}: {
    displayMode: string
}) {
    return (
        <>
            {displayMode === 'grid' ? (
                <div className="flex justify-center">
                    <Card className="w-full h-full border rounded-xl shadow-sm overflow-hidden flex flex-col">
                        <CardContent className="p-0 flex flex-col h-full">
                            {/* 1. Blog Image Skeleton */}
                            <Skeleton className="aspect-video w-full rounded-none" />

                            <div className="p-4 flex flex-col flex-1 gap-3">
                                {/* 2. Title Skeleton (2 lines) */}
                                <div className="space-y-2">
                                    <Skeleton className="h-5 w-full" />
                                    <Skeleton className="h-5 w-[80%]" />
                                </div>

                                {/* 3. Description Skeleton (3 lines) */}
                                <div className="space-y-2 mt-2">
                                    <Skeleton className="h-3 w-full" />
                                    <Skeleton className="h-3 w-full" />
                                    <Skeleton className="h-3 w-[40%]" />
                                </div>

                                {/* 4. Footer (Author & Date) */}
                                <div className="mt-auto pt-4 flex justify-between items-center">
                                    <Skeleton className="h-4 w-24" /> {/* Author */}
                                    <Skeleton className="h-4 w-20" /> {/* Date */}
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            ) : (
                /* List View: Horizontal layout */
                <Card className="w-full min-h-[200px] border rounded-xl shadow-sm overflow-hidden">
                    <CardContent className="p-0 flex h-full">
                        <Skeleton className="w-[300px] h-full rounded-none" />

                        <div className="p-6 flex flex-col flex-1 gap-4">
                            <div className="space-y-2">
                                <Skeleton className="h-6 w-[70%]" />
                                <Skeleton className="h-3 w-full" />
                                <Skeleton className="h-3 w-full" />
                            </div>

                            <div className="mt-auto flex justify-between">
                                <Skeleton className="h-4 w-32" />
                                <Skeleton className="h-4 w-24" />
                            </div>
                        </div>
                    </CardContent>
                </Card>
            )}
        </>
    );
}